<template>
  <section class="container">
    <div class="orders">
      <div class="orders__card">
        <el-tabs v-model="TabActive" class="orders__tabs">
          <el-tab-pane :label="$t('orders.tab.all')" name="all">
            <div v-if="PageInfo.data && PageInfo.data.length" class="orders__content">
              <el-table :data="PageInfo.data" class="orders__table">
                <el-table-column
                  :label="$t('orders.column.orderNumber')"
                  min-width="200"
                >
                  <template slot-scope="scope">
                    <router-link
                      :to="`/member/orders/${scope.row.orderId}`"
                      class="orders__code"
                    >
                      {{ scope.row.orderCode }}
                    </router-link>
                  </template>
                </el-table-column>

                <el-table-column
                  :label="$t('orders.column.status')"
                  width="120"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-tag
                      :type="statusNameType(scope.row.statusName)"
                      size="medium"
                    >
                      {{ scope.row.statusName }}
                    </el-tag>
                  </template>
                </el-table-column>

                <el-table-column
                  :label="$t('orders.column.paymentMethod')"
                  min-width="120"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{ scope.row.orderPayModeName }}
                  </template>
                </el-table-column>

                <el-table-column
                  :label="$t('orders.column.amount')"
                  min-width="120"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{ scope.row.orderActualPrice | toCurrency }}
                  </template>
                </el-table-column>

                <el-table-column
                  :label="$t('orders.column.purchaseTime')"
                  min-width="170"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{ scope.row.orderDate | toTaipei | moment('YYYY-MM-DD HH:mm:ss') }}
                  </template>
                </el-table-column>
              </el-table>

              <div class="orders__pagination">
                <el-pagination
                  background
                  layout="total, prev, pager, next, jumper"
                  :total="PageInfo.count"
                  :page-size="Pagination.pageSize"
                  :current-page.sync="Pagination.pageIndex"
                  @current-change="GetList"
                />
              </div>
            </div>

            <div v-else class="orders__empty">
              <i class="el-icon-document"></i>
              <p>{{ $t('orders.message.noOrders') }}</p>
            </div>
          </el-tab-pane>

          <el-tab-pane :label="$t('orders.tab.pending')" name="pending">
            <div v-if="PageInfoByMid.data && PageInfoByMid.data.length" class="orders__content">
              <el-table :data="PageInfoByMid.data" class="orders__table">
                <el-table-column
                  :label="$t('orders.column.orderNumber')"
                  min-width="200"
                >
                  <template slot-scope="scope">
                    <router-link
                      :to="`/member/orders/${scope.row.orderId}`"
                      class="orders__code"
                    >
                      {{ scope.row.orderCode }}
                    </router-link>
                  </template>
                </el-table-column>

                <el-table-column
                  :label="$t('orders.column.paymentMethod')"
                  min-width="120"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{ scope.row.orderPayModeName }}
                  </template>
                </el-table-column>

                <el-table-column
                  :label="$t('orders.column.amount')"
                  min-width="120"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{ scope.row.orderActualPrice | toCurrency }}
                  </template>
                </el-table-column>

                <el-table-column
                  :label="$t('orders.column.purchaseTime')"
                  min-width="170"
                  align="center"
                >
                  <template slot-scope="scope">
                    {{ scope.row.orderDate | toTaipei | moment('YYYY-MM-DD HH:mm:ss') }}
                  </template>
                </el-table-column>

                <el-table-column
                  :label="$t('common.label.actions')"
                  min-width="200"
                  align="center"
                >
                  <template slot-scope="scope">
                    <div class="orders__actions">
                      <el-button
                        v-if="scope.row.payStatus === 1"
                        type="success"
                        size="small"
                        @click="gotoStep2(scope.row.orderId)"
                      >
                        {{ $t('orders.button.checkout') }}
                      </el-button>

                      <el-button
                        v-if="(scope.row.isCancelBtn & 2) === 2"
                        type="primary"
                        size="small"
                        @click="CopyOrderById(scope.row)"
                      >
                        {{ $t('orders.button.reorder') }}
                      </el-button>

                      <el-button
                        v-if="(scope.row.isCancelBtn & 1) === 1"
                        type="danger"
                        size="small"
                        @click="CancelOrderById(scope.row)"
                      >
                        {{ $t('orders.button.cancelOrder') }}
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>

              <div class="orders__pagination">
                <el-pagination
                  background
                  layout="total, prev, pager, next, jumper"
                  :total="PageInfoByMid.count"
                  :page-size="PaginationByMid.pageSize"
                  :current-page.sync="PaginationByMid.pageIndex"
                  @current-change="GetListByMid"
                />
              </div>
            </div>

            <div v-else class="orders__empty">
              <i class="el-icon-document"></i>
              <p>{{ $t('orders.message.noPendingOrders') }}</p>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </section>
</template>

<script>
import {
  GetOrders, GetOrdersByMidState, CancelOrderById, CopyOrderById,
} from '@/api/OrderApi';

export default {
  data() {
    return {
      Pagination: {
        // 有分頁要有此model data
        pageIndex: 1, // 預設從第幾頁開始
        pageSize: 6, // 預設每頁幾筆
        data: {},
      },
      PageInfo: {
        count: 0, // api給的總筆數
        data: [],
      },
      PaginationByMid: {
        // 有分頁要有此model data
        pageIndex: 1, // 預設從第幾頁開始
        pageSize: 6, // 預設每頁幾筆
        data: {},
      },
      PageInfoByMid: {
        count: 0, // api給的總筆數
        data: [],
      },
      TabActive: 'all',
    };
  },
  // 當有設定keep的時候，返回到此頁面會執行這個，不會執行created()，所以這邊就不用放created()
  async activated() {
    if (!this.$route.meta.isBack) {
      // 不是從指定頁面返回的話，進行初始化設定
      this.Pagination = {
        pageIndex: 1, // 預設從第幾頁開始
        pageSize: 6, // 預設每頁幾筆
        data: {
          categoryId: 0,
        },
      };
      this.PaginationByMid = {
        pageIndex: 1, // 預設從第幾頁開始
        pageSize: 6, // 預設每頁幾筆
        data: {
          categoryId: 0,
        },
      };
      this.PageInfo = {
        count: 0, // api給的總筆數
        data: [],
      };
    }
    // 然後再針對頁面進行初始化資料存取
    this.GetList();
    this.GetListByMid();
  },
  // created() {
  //   this.GetList();
  //   this.GetListByMid();
  // },
  mounted() {},
  methods: {
    GetList() {
      GetOrders(this.Pagination).then((response) => {
        if (response.data.statusCode === 0) {
          this.PageInfo.count = response.data.count;
          this.PageInfo.data = response.data.data;
          if (this.Pagination.pageIndex !== 1 && this.PageInfo.data.length === 0) {
            this.Pagination.pageIndex = 1;
            this.GetList();
          }
        }
      });
    },
    GetListByMid() {
      GetOrdersByMidState(this.PaginationByMid).then((response) => {
        if (response.data.statusCode === 0) {
          this.PageInfoByMid.count = response.data.count;
          this.PageInfoByMid.data = response.data.data;
          if (this.PaginationByMid.pageIndex !== 1 && this.PageInfoByMid.data.length === 0) {
            this.GetListByMid();
          }
        }
      });
    },
    CopyOrderById(item) {
      this.$confirm(
        this.$t('orders.message.confirmReorder', { orderId: item.orderCode }),
        this.$t('common.dialog.title'),
        {
          confirmButtonText: this.$t('common.button.confirm'),
          cancelButtonText: this.$t('common.button.cancel'),
          type: 'warning',
        },
      )
        .then(() => {
          CopyOrderById(item.orderId).then((response) => {
            if (response.data.statusCode === 0) {
              this.GetList();
              this.GetListByMid();
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('orders.message.reorderSuccess'),
              });
            }
          });
        })
        .catch(() => {});
    },
    CancelOrderById(item) {
      this.$confirm(
        this.$t('orders.message.confirmCancel', { orderId: item.orderCode }),
        this.$t('common.dialog.title'),
        {
          confirmButtonText: this.$t('common.button.confirm'),
          cancelButtonText: this.$t('common.button.cancel'),
          type: 'warning',
        },
      )
        .then(() => {
          CancelOrderById(item.orderId).then((response) => {
            if (response.data.statusCode === 0) {
              this.GetList();
              this.GetListByMid();
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('orders.message.cancelSuccess'),
              });
            }
          });
        })
        .catch(() => {});
    },
    statusNameType(status) {
      if (status === this.$t('orders.status.completed')) {
        return 'primary';
      }

      if (status === this.$t('orders.status.failed')) {
        return 'danger';
      }

      if (status === this.$t('orders.status.cancelled')) {
        return 'warning';
      }

      return 'success';
    },
    gotoStep2(orderId) {
      this.$router.push({ path: `/shopping/step2/${orderId}` });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.orders {
  &__card {
    background-color: var(--background-white);
    border-radius: var(--border-radius-lg);
    border: 1px solid var(--border-light);
    box-shadow: var(--shadow-sm);
    overflow: hidden;
  }

  &__tabs {
    /deep/ .el-tabs__header {
      margin: 0;
      background-color: var(--background-light);
      padding: 0 32px;

      @media (max-width: $breakpoint-sm) {
        padding: 0 20px;
      }
    }

    /deep/ .el-tabs__nav-wrap::after {
      display: none;
    }

    /deep/ .el-tabs__item {
      height: 56px;
      line-height: 56px;
      font-size: var(--font-size-base);
      font-weight: 600;
      color: var(--text-regular);
      transition: all var(--transition-base);

      &.is-active {
        color: var(--primary-color);
      }

      &:hover {
        color: var(--primary-color);
      }
    }

    /deep/ .el-tabs__active-bar {
      height: 3px;
      background-color: var(--primary-color);
    }

    /deep/ .el-tabs__content {
      padding: 0;
    }
  }

  &__content {
    padding: 24px 32px 32px;

    @media (max-width: $breakpoint-sm) {
      padding: 20px;
    }
  }

  &__table {
    margin-bottom: 24px;

    /deep/ .el-table__header th {
      background-color: var(--background-base);
      color: var(--text-primary);
      font-weight: 600;
      font-size: var(--font-size-sm);
    }

    /deep/ .el-table__row {
      transition: background-color var(--transition-fast);

      &:hover {
        background-color: var(--primary-light-color);
      }
    }

    /deep/ .el-table--border,
    /deep/ .el-table--group {
      border: none;
    }

    /deep/ .el-table__body-wrapper {
      border-radius: var(--border-radius-base);
    }
  }

  &__code {
    color: var(--primary-color);
    text-decoration: none;
    font-weight: 600;
    transition: color var(--transition-fast);

    &:hover {
      color: #0088cc;
      text-decoration: underline;
    }
  }

  &__actions {
    display: flex;
    gap: 8px;
    justify-content: center;
    flex-wrap: wrap;
  }

  &__pagination {
    display: flex;
    justify-content: center;

    /deep/ .el-pagination {
      font-weight: normal;
    }

    /deep/ .el-pagination__total {
      color: var(--text-regular);
    }
  }

  &__empty {
    padding: 80px 20px;
    text-align: center;
    color: var(--text-secondary);

    i {
      font-size: 64px;
      color: var(--text-placeholder);
      margin-bottom: 16px;
      display: block;
    }

    p {
      font-size: var(--font-size-base);
      margin: 0;
    }
  }
}
</style>
